
export const exportToExcel = (obj: object[]) => {

    if (obj.length < 1) return;

    const keysArray = Object.keys(obj[0]);
    const valuesArray = [keysArray];

    for (let index = 0; index < obj.length; index++) {

        const item = obj[index];
        const valueArray = [];

        for (let v = 0; v < keysArray.length; v++) {
            const key = keysArray[v];
            const value = item[key] || "";

            valueArray.push(value.toString().replaceAll(",", " "));
        }

        valuesArray.push(valueArray);
    }


    var CsvString = "";
    valuesArray.forEach(function (RowItem, RowIndex) {
        RowItem.forEach(function (ColItem, ColIndex) {
            CsvString += ColItem + ',';
        });
        CsvString += "\r\n";
    });
    // CsvString = "data:application/csv," + encodeURIComponent(CsvString);
    CsvString = "data:application/csv;charset=utf-8,%EF%BB%BF" + encodeURIComponent(CsvString);

    //data:text/csv;charset=utf-8,%EF%BB%BF" 
    var x = document.createElement("A");
    x.setAttribute("href", CsvString);
    x.setAttribute("download", "formularios-exportados_" + (+new Date()) + "_.csv");
    document.body.appendChild(x);
    x.click();



}